import { Dispatch } from "@reduxjs/toolkit";
import { getFieldsForTab } from "../../../services/api/fields.api";
import {
  FieldType,
  ReportFieldType,
  TabType,
} from "../../../services/helpers/types";
import { TFunction } from "i18next";

export const getFieldsForReport = async (
  t: TFunction,
  dispatch: Dispatch,
  fields: FieldType[],
  tabs: TabType[]
): Promise<ReportFieldType[]> => {
  if (fields.length > 0) {
    const currentlyLoadedFieldsTabID = fields[0].tabID;
    const currentTab = tabs.find(
      (tab) => tab.tabID === currentlyLoadedFieldsTabID
    );
    const tabsNotLoaded = tabs.filter(
      (tab) => tab.tabID !== currentlyLoadedFieldsTabID
    );
    const unloadedFieldsPromise = tabsNotLoaded.map(async (tab) => {
      return {
        tab: `t-${tab.tabID}`,
        name: tab.name,
        value: tab.value,
        data: await getFieldsForTab(t, dispatch, tab.tabID),
      };
    });
    const unloadedFields = await Promise.all(unloadedFieldsPromise);
    const loadedFields = {
      tab: `t-${currentTab?.tabID}`,
      name: currentTab?.name,
      value: currentTab?.value,
      data: fields,
    };
    return [loadedFields, ...unloadedFields.flat()];
  }
  return [];
};
